import React from "react";

const shots = [
  { src: "/Coffee32.jpg", label: "Roasting machine" },
  { src: "/Coffee33.jpg", label: "Cooling tray" },
  { src: "/Coffee30.jpg", label: "Roaster checking beans" },
  { src: "/kbl-bag.png", label: "Packaging" },
];

const Roastery = () => {
  return (
    <section className="bg-espresso px-5 py-16 text-cream md:px-8 md:py-20 lg:px-12">
      <div className="mx-auto max-w-7xl">
        <div className="mb-10 max-w-2xl">
          <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-gold">
            Craftsmanship
          </p>
          <h2 className="mt-3 font-display text-3xl md:text-4xl">
            Inside Our Roastery
          </h2>
          <p className="mt-4 text-cream/75">
            Small-batch weekly roasting is our competitive advantage—freshness you can
            taste from the first pour.
          </p>
        </div>

        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
          {shots.map((shot, i) => (
            <figure
              key={shot.label}
              className={`relative overflow-hidden rounded-2xl ${
                i === 0 ? "md:col-span-2 md:row-span-2 min-h-[18rem]" : "min-h-[12rem]"
              }`}
            >
              <img
                src={shot.src}
                alt={shot.label}
                className="absolute inset-0 h-full w-full object-cover transition duration-700 hover:scale-105"
              />
              <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-espresso/80 to-transparent p-4 text-sm font-medium">
                {shot.label}
              </figcaption>
            </figure>
          ))}
        </div>

        <p className="mt-8 inline-flex rounded-full border border-gold/40 px-5 py-2 text-sm font-semibold text-gold">
          Small Batch Weekly · Freshness First
        </p>
      </div>
    </section>
  );
};

export default Roastery;
